"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTapeBuilderRecordGeneratedFinancialDataConfiguration = exports.validateTapeBuilderRecordUI = exports.isTapeBuilderRecordCashResponseTape = exports.isTapeBuilderRecordFundingRequest = exports.isTapeBuilderRecordConfigTapeConfiguration = exports.isTapeBuilderInternalRepaymentTapeConfiguration = exports.isTapeBuilderRecordInternalRepaymentTape = exports.isTapeBuilderGeneratedRepaymentTapeConfiguration = exports.isTapeBuilderRecordGeneratedReceivableInvoiceTapeConfiguration = exports.isTapeBuilderRecordOrgProvidedInputConfiguration = exports.isTapeBuilderRecordValleyBankIngestTapeConfiguration = exports.isTapeBuilderRecordForwardedTapeConfiguration = exports.isTapeBuilderRecordGeneratedCovenantLoanTapeConfiguration = exports.isTapeBuilderRecordAssignedRepaymentTape = exports.isTapeBuilderRecordGeneratedRepaymentTape = exports.isTapeBuilderRecordBorrowingBaseReport = exports.isTapeBuilderRecordGeneratedLoanTape = exports.isTapeBuilderDbRecordSyntheticBorrowingBaseReport = exports.isTapeBuilderRecordDB = exports.isTapeBuilderRecordUI = exports.isTapeBuilderTask = exports.isTapeBuilderTaskWithTapeDefinition = exports.isTapeBuilderRecordFundingRequestConfiguration = exports.isTapeBuilderRecordRawReceivableDocumentationConfiguration = exports.isTapeBuilderSyntheticBorrowingBaseReportConfiguration = exports.isTapeBuilderRecordFundingApprovalReportConfiguration = exports.isTapeBuilderRecordFundingVerificationReportConfiguration = exports.isTapeBuilderMasterLoanTapeConfiguration = exports.isTapeBuilderPreFilterTask = exports.isTapeBuilderSanitizeTask = exports.isTapeBuilderXlsx2CsvTask = void 0;
/* eslint-disable no-console */
const jsonschema_1 = __importDefault(require("jsonschema"));
const common_1 = require("@finley-technologies/common");
const finley_types_1 = require("@finley-technologies/finley-types");
const schema_1 = require("./schema");
const isTapeBuilderXlsx2CsvTask = (obj) => {
    const result = jsonschema_1.default.validate(obj, schema_1.schema.TapeBuilderXlsx2CsvTaskSchema);
    return result.valid;
};
exports.isTapeBuilderXlsx2CsvTask = isTapeBuilderXlsx2CsvTask;
const isTapeBuilderSanitizeTask = (obj) => {
    const result = jsonschema_1.default.validate(obj, schema_1.schema.TapeBuilderSanitizeTaskSchema);
    return result.valid;
};
exports.isTapeBuilderSanitizeTask = isTapeBuilderSanitizeTask;
const isTapeBuilderPreFilterTask = (obj) => {
    const result = jsonschema_1.default.validate(obj, schema_1.schema.TapeBuilderPreFilterTaskSchema);
    return result.valid;
};
exports.isTapeBuilderPreFilterTask = isTapeBuilderPreFilterTask;
const isTapeBuilderMasterLoanTapeConfiguration = (obj) => {
    const result = jsonschema_1.default.validate(obj, schema_1.schema.TapeBuilderMasterLoanTapeConfigurationSchema);
    return result.valid;
};
exports.isTapeBuilderMasterLoanTapeConfiguration = isTapeBuilderMasterLoanTapeConfiguration;
const isTapeBuilderRecordFundingVerificationReportConfiguration = (obj) => {
    const result = jsonschema_1.default.validate(obj, schema_1.schema.TapeBuilderRecordFundingVerificationReportConfiguration);
    return result.valid;
};
exports.isTapeBuilderRecordFundingVerificationReportConfiguration = isTapeBuilderRecordFundingVerificationReportConfiguration;
const isTapeBuilderRecordFundingApprovalReportConfiguration = (obj) => {
    const result = jsonschema_1.default.validate(obj, schema_1.schema.TapeBuilderRecordFundingApprovalReportConfiguration);
    return result.valid;
};
exports.isTapeBuilderRecordFundingApprovalReportConfiguration = isTapeBuilderRecordFundingApprovalReportConfiguration;
const isTapeBuilderSyntheticBorrowingBaseReportConfiguration = (obj) => {
    const result = jsonschema_1.default.validate(obj, schema_1.schema.TapeBuilderSyntheticBorrowingBaseReportConfigurationSchema);
    return result.valid;
};
exports.isTapeBuilderSyntheticBorrowingBaseReportConfiguration = isTapeBuilderSyntheticBorrowingBaseReportConfiguration;
const isTapeBuilderRecordRawReceivableDocumentationConfiguration = (obj) => {
    const result = jsonschema_1.default.validate(obj, schema_1.schema.TapeBuilderRecordRawReceivableDocumentationConfigurationSchema);
    return result.valid;
};
exports.isTapeBuilderRecordRawReceivableDocumentationConfiguration = isTapeBuilderRecordRawReceivableDocumentationConfiguration;
const isTapeBuilderRecordFundingRequestConfiguration = (obj) => {
    const result = jsonschema_1.default.validate(obj, schema_1.schema.TapeBuilderRecordFundingRequestConfigurationSchema);
    if (!result.valid) {
        console.log('Not isTapeBuilderRecordFundingRequestConfiguration:', result);
    }
    return result.valid;
};
exports.isTapeBuilderRecordFundingRequestConfiguration = isTapeBuilderRecordFundingRequestConfiguration;
const isTapeBuilderTaskWithTapeDefinition = (obj) => {
    const result = jsonschema_1.default.validate(obj, schema_1.schema.TapeBuilderTaskWithTapeDefinitionSchema);
    if (!result.valid) {
        console.log('Not TapeBuilderTaskWithTapeDefinitionSchema:', result);
    }
    return result.valid;
};
exports.isTapeBuilderTaskWithTapeDefinition = isTapeBuilderTaskWithTapeDefinition;
const isTapeBuilderTask = (obj) => {
    const result = jsonschema_1.default.validate(obj, schema_1.schema.TapeBuilderTaskSchema);
    if (!result.valid) {
        console.log('Not TapeBuilderTaskSchema:', result);
    }
    return result.valid;
};
exports.isTapeBuilderTask = isTapeBuilderTask;
const isTapeBuilderRecordUI = (obj) => {
    // we call this at runtime, must strip of the db timestamp fields
    // before calling validating this.
    const result = jsonschema_1.default.validate(common_1.utils.stripDbTimeStamps(obj), schema_1.schema.TapeBuilderRecordUISchema);
    if (!result.valid) {
        // this is an important log statement needed for debugging,
        // do not remove while we are still developing tape-builder
        console.log('isTapeBuilderRecordUI: not a tape-builder record ui:', result);
    }
    return result.valid;
};
exports.isTapeBuilderRecordUI = isTapeBuilderRecordUI;
const isTapeBuilderRecordDB = (obj) => {
    // we call this at runtime, must strip of the db timestamp fields
    // before calling validating this.
    const result = jsonschema_1.default.validate(common_1.utils.stripDbTimeStamps(obj), schema_1.schema.TapeBuilderRecordDBSchema, {
        nestedErrors: true,
    });
    if (!result.valid) {
        // this is an important log statement needed for debugging,
        // do not remove while we are still developing tape-builder
        console.log('not a tape-builder db record db:', result);
    }
    return result.valid;
};
exports.isTapeBuilderRecordDB = isTapeBuilderRecordDB;
const isTapeBuilderDbRecordSyntheticBorrowingBaseReport = (obj) => {
    return obj.type === 'borrowingBaseReport';
};
exports.isTapeBuilderDbRecordSyntheticBorrowingBaseReport = isTapeBuilderDbRecordSyntheticBorrowingBaseReport;
const isTapeBuilderRecordGeneratedLoanTape = (obj) => {
    return obj.type === 'generatedLoanTape';
};
exports.isTapeBuilderRecordGeneratedLoanTape = isTapeBuilderRecordGeneratedLoanTape;
const isTapeBuilderRecordBorrowingBaseReport = (obj) => {
    // we call this at runtime, must strip of the db timestamp fields
    // before calling validating this.
    const result = jsonschema_1.default.validate(common_1.utils.stripDbTimeStamps(obj), schema_1.schema.TapeBuilderRecordBorrowingBaseReportSchema);
    if (!result.valid) {
        // this is an important log statement needed for debugging,
        // do not remove while we are still developing tape-builder
        console.log('not a tape-builder borrowing base report record:', result);
    }
    return result.valid;
};
exports.isTapeBuilderRecordBorrowingBaseReport = isTapeBuilderRecordBorrowingBaseReport;
const isTapeBuilderRecordGeneratedRepaymentTape = (obj) => {
    // Called at runtime, must strip of the db timestamp fields before validating this
    const result = jsonschema_1.default.validate(common_1.utils.stripDbTimeStamps(obj), schema_1.schema.TapeBuilderRecordGeneratedRepaymentTapeSchema);
    if (!result.valid) {
        // this is an important log statement needed for debugging,
        // do not remove while we are still developing tape-builder
        console.log('Not a tape-builder Generated Repayment Tape record:', result);
    }
    return result.valid;
};
exports.isTapeBuilderRecordGeneratedRepaymentTape = isTapeBuilderRecordGeneratedRepaymentTape;
const isTapeBuilderRecordAssignedRepaymentTape = (obj) => {
    // Called at runtime, must strip of the db timestamp fields before validating this
    const result = jsonschema_1.default.validate(common_1.utils.stripDbTimeStamps(obj), schema_1.schema.TapeBuilderRecordAssignedRepaymentTapeSchema);
    if (!result.valid) {
        console.log('Not a tape-builder Assigned Repayment Tape record:', result);
    }
    return result.valid;
};
exports.isTapeBuilderRecordAssignedRepaymentTape = isTapeBuilderRecordAssignedRepaymentTape;
const isTapeBuilderRecordGeneratedCovenantLoanTapeConfiguration = (obj) => {
    const result = jsonschema_1.default.validate(obj, schema_1.schema.TapeBuilderRecordGeneratedCovenantLoanTapeConfiguration);
    return result.valid;
};
exports.isTapeBuilderRecordGeneratedCovenantLoanTapeConfiguration = isTapeBuilderRecordGeneratedCovenantLoanTapeConfiguration;
const isTapeBuilderRecordForwardedTapeConfiguration = (obj) => {
    const result = jsonschema_1.default.validate(obj, schema_1.schema.TapeBuilderRecordForwardedTapeConfiguration);
    return result.valid;
};
exports.isTapeBuilderRecordForwardedTapeConfiguration = isTapeBuilderRecordForwardedTapeConfiguration;
const isTapeBuilderRecordValleyBankIngestTapeConfiguration = (obj) => {
    const result = jsonschema_1.default.validate(obj, schema_1.schema.TapeBuilderRecordValleyBankIngestTapeConfiguration);
    return result.valid;
};
exports.isTapeBuilderRecordValleyBankIngestTapeConfiguration = isTapeBuilderRecordValleyBankIngestTapeConfiguration;
const isTapeBuilderRecordOrgProvidedInputConfiguration = (obj) => {
    const result = jsonschema_1.default.validate(obj, schema_1.schema.TapeBuilderRecordOrgProvidedInputConfiguration);
    return result.valid;
};
exports.isTapeBuilderRecordOrgProvidedInputConfiguration = isTapeBuilderRecordOrgProvidedInputConfiguration;
const isTapeBuilderRecordGeneratedReceivableInvoiceTapeConfiguration = (obj) => {
    const result = jsonschema_1.default.validate(obj, schema_1.schema.TapeBuilderRecordGeneratedReceivableInvoiceTapeConfigurationSchema);
    return result.valid;
};
exports.isTapeBuilderRecordGeneratedReceivableInvoiceTapeConfiguration = isTapeBuilderRecordGeneratedReceivableInvoiceTapeConfiguration;
const isTapeBuilderGeneratedRepaymentTapeConfiguration = (obj) => {
    // Called at runtime, must strip of the db timestamp fields before validating this
    const result = jsonschema_1.default.validate(common_1.utils.stripDbTimeStamps(obj), schema_1.schema.TapeBuilderGeneratedRepaymentTapeConfiguration);
    if (!result.valid) {
        console.log('Not a tape-builder Generated Repayment Tape Configuration:', result);
    }
    return result.valid;
};
exports.isTapeBuilderGeneratedRepaymentTapeConfiguration = isTapeBuilderGeneratedRepaymentTapeConfiguration;
const isTapeBuilderRecordInternalRepaymentTape = (obj) => {
    // Called at runtime, must strip of the db timestamp fields before validating this
    const result = jsonschema_1.default.validate(common_1.utils.stripDbTimeStamps(obj), schema_1.schema.TapeBuilderRecordInternalRepaymentTapeSchema);
    if (!result.valid) {
        // this is an important log statement needed for debugging,
        // do not remove while we are still developing tape-builder
        console.log('Not a tape-builder Internal Repayment Tape record:', result);
    }
    return result.valid;
};
exports.isTapeBuilderRecordInternalRepaymentTape = isTapeBuilderRecordInternalRepaymentTape;
const isTapeBuilderInternalRepaymentTapeConfiguration = (obj) => {
    const result = jsonschema_1.default.validate(obj, schema_1.schema.TapeBuilderInternalRepaymentTapeConfiguration);
    return result.valid;
};
exports.isTapeBuilderInternalRepaymentTapeConfiguration = isTapeBuilderInternalRepaymentTapeConfiguration;
const isTapeBuilderRecordConfigTapeConfiguration = (obj) => {
    const result = jsonschema_1.default.validate(obj, schema_1.schema.TapeBuilderRecordConfigTapeConfigurationSchema);
    return result.valid;
};
exports.isTapeBuilderRecordConfigTapeConfiguration = isTapeBuilderRecordConfigTapeConfiguration;
const isTapeBuilderRecordFundingRequest = (obj) => {
    // we call this at runtime, must strip of the db timestamp fields
    // before calling validating this.
    const result = jsonschema_1.default.validate(common_1.utils.stripDbTimeStamps(obj), schema_1.schema.TapeBuilderRecordFundingRequestSchema);
    if (!result.valid) {
        // this is an important log statement needed for debugging,
        // do not remove while we are still developing tape-builder
        console.log('not a tape-builder funding request record:', result);
    }
    return result.valid;
};
exports.isTapeBuilderRecordFundingRequest = isTapeBuilderRecordFundingRequest;
const isTapeBuilderRecordCashResponseTape = (obj) => {
    // Called at runtime, must strip of the db timestamp fields before validating this
    const result = jsonschema_1.default.validate(common_1.utils.stripDbTimeStamps(obj), schema_1.schema.TapeBuilderRecordCashResponseTapeSchema);
    if (!result.valid) {
        // this is an important log statement needed for debugging,
        // do not remove while we are still developing tape-builder
        console.log('Not a tape-builder Cash Response Tape record:', result);
    }
    return result.valid;
};
exports.isTapeBuilderRecordCashResponseTape = isTapeBuilderRecordCashResponseTape;
// This is not strictly a typeguard in the sense that it doesn't return a boolean.
const validateTapeBuilderRecordUI = (obj) => {
    const result = jsonschema_1.default.validate(obj, schema_1.schema.TapeBuilderRecordUISchema);
    if (!result.valid) {
        // this is an important log statement needed for debugging,
        // do not remove while we are still developing tape-builder
        console.log('validateTapeBuilderRecordUI: not a tape-builder record ui:', result);
    }
    return {
        isValid: result.valid,
        // TODO: add more info to error messages
        errorMessages: result.errors.map((error) => error.message),
    };
};
exports.validateTapeBuilderRecordUI = validateTapeBuilderRecordUI;
exports.isTapeBuilderRecordGeneratedFinancialDataConfiguration = finley_types_1.typeguards.typeguardFunctionLogWrapper({
    schema: schema_1.schema.TapeBuilderRecordGeneratedFinancialDataConfiguration,
    typeguardName: 'isTapeBuilderRecordGeneratedFinancialDataConfiguration',
});
//# sourceMappingURL=typeguards.js.map